// AUTO-GENERATED by scripts/gen-name-index.ts — do not edit by hand.
export interface PoaJurisdictionName { slug: string; nameTh: string; nameEn: string; hagueParty: boolean }
export const POA_JURISDICTION_NAMES: PoaJurisdictionName[] = [
  {
    "slug": "united-states",
    "nameTh": "สหรัฐอเมริกา",
    "nameEn": "United States",
    "hagueParty": true
  },
  {
    "slug": "united-kingdom",
    "nameTh": "สหราชอาณาจักร",
    "nameEn": "United Kingdom",
    "hagueParty": true
  },
  {
    "slug": "australia",
    "nameTh": "ออสเตรเลีย",
    "nameEn": "Australia",
    "hagueParty": true
  },
  {
    "slug": "germany",
    "nameTh": "เยอรมนี",
    "nameEn": "Germany",
    "hagueParty": true
  },
  {
    "slug": "japan",
    "nameTh": "ญี่ปุ่น",
    "nameEn": "Japan",
    "hagueParty": true
  },
  {
    "slug": "south-korea",
    "nameTh": "เกาหลีใต้",
    "nameEn": "South Korea",
    "hagueParty": true
  },
  {
    "slug": "china",
    "nameTh": "จีน",
    "nameEn": "China",
    "hagueParty": true
  },
  {
    "slug": "uae",
    "nameTh": "สหรัฐอาหรับเอมิเรตส์",
    "nameEn": "United Arab Emirates",
    "hagueParty": false
  }
];
